'use client';

import React from 'react';
import { translateMessage } from '@/lib/static-intl';

function resolveStaticText(translationKey, text) {
  if (translationKey) {
    const translated = translateMessage(null, translationKey);
    if (translated && translated !== translationKey) return translated;
  }
  return text || translationKey || '';
}

export function SmartTranslation({
  translationKey,
  text,
  sourceLanguage,
  isDynamic,
  autoTranslate,
  as: Component = 'span',
  children,
  ...props
}) {
  return (
    <Component {...props}>
      {children ?? resolveStaticText(translationKey, text)}
    </Component>
  );
}

export default SmartTranslation;
